export const StepId = Object.freeze({
  VERIFY_EMAIL: 'verificar-email',
  VERIFICATION_CODE: 'verificar-codigo',
  NEW_PASSWORD: 'nueva-contrasena',
  DATOS_PERSONALES: 'datos-personales',
})
